import { CodeBook } from "@king-ict/eupisi-ui/models";

export interface ProgramCodeBook extends CodeBook {
  code: string;
  programTypeEMaticaId?: number;
  programTypeEMaticaName: string;
  programTypeId: number;
  programTypeName: string;
  qualificationTypeId?: number;
  qualificationType?: string;
  hkoLevelId: number;
  hkoLevelName: string;
  educationSectorId?: number;
  educationSectorName: string;
  educationSubSectorId?: number;
  educationSubSectorName: string;
  qualificationId?: number;
  qualificationName: string;
  professionFieldId?: number,
  professionFieldName: string,
  languageId?: number;
  languageName: string;
  professionId?: number;
  professionName: string;
  dateTo?: Date;
  canDelete: boolean;
}

export const programInitial = (): ProgramCodeBook => {
  return {
    id: 0,
    name: "",
    code: "",
    programTypeEMaticaId: 0,
    programTypeEMaticaName: "",
    programTypeId: 0,
    hkoLevelName: "",
    programTypeName: "",
    hkoLevelId: 0,
    educationSectorId: 0,
    educationSectorName: "",
    educationSubSectorId: 0,
    educationSubSectorName: "",
    qualificationId: 0,
    qualificationName: "",
    professionFieldId: 0,
    professionFieldName: "",
    languageId: 0,
    languageName: "",
    professionId: 0,
    professionName: "",
    canDelete: false
  }
}
